import { render, staticRenderFns } from "./SchoolDashboard.vue?vue&type=template&id=50e9b0af"
import script from "./SchoolDashboard.vue?vue&type=script&lang=js"
export * from "./SchoolDashboard.vue?vue&type=script&lang=js"
import style0 from "./SchoolDashboard.vue?vue&type=style&index=0&id=50e9b0af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports